/**
 * @file Generated by js-routes 2.4.1. Based on Rails 8.0.5.1 routes of Hubstaff::Application.
 * @version d8e759532d4c1a71efc106bac19382fbe65a737dbe4be85e3de67159cbee4bcb
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
const __jsr = (() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "",
        default_url_options: {},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: true,
        include_undefined_query_parameters: false,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("ESM", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const __route = __jsr.__route;

/**
 * Generates rails route to
 * /organizations/:id/scim/Groups(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const Groups_scim_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/scim/Users(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const Users_scim_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"scim"],[2,[7,"/"],[2,[6,"Users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/accept_essentials_churn_offer(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_essentials_churn_offer_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept_essentials_churn_offer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/mfa(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_mfa_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"mfa"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/achievements(/:achievement)(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const achievement_setting_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"achievement":{},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"achievements"],[2,[1,[2,[7,"/"],[3,"achievement"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/achievements(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const achievement_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"achievements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/activate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activate_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/activate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activate_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_and_activities_reports/add_custom_filter(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_custom_filter_organization_time_and_activities_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_and_activities_reports"],[2,[7,"/"],[2,[6,"add_custom_filter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/payer_accounts/:id/add_members(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_members_organization_payer_account_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/add_users(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_users_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /welcome/added(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const added_welcome_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"welcome"],[2,[7,"/"],[2,[6,"added"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/advertisement_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const advertisement_modal_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"advertisement_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/smart_notification_rules/alerts(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alerts_organization_smart_notification_rules_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"smart_notification_rules"],[2,[7,"/"],[2,[6,"alerts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /analytics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytics_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/app_sumo_upgrade(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const app_sumo_upgrade_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"app_sumo_upgrade"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /appcast(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appcast_path = /*#__PURE__*/ __route({"format":{"d":"xml"}}, [2,[7,"/"],[2,[6,"appcast"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/apply_coupon(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apply_coupon_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply_coupon"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/paid_addons/:addon_sym/apply_coupon(.:format)
 * @param {any} organization_id
 * @param {any} addon_sym
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apply_coupon_organization_paid_addons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"addon_sym":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"paid_addons"],[2,[7,"/"],[2,[3,"addon_sym"],[2,[7,"/"],[2,[6,"apply_coupon"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /time_entries/approve_manual_time_request(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_manual_time_request_time_entries_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"approve_manual_time_request"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /time_off_requests/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_time_off_request_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"time_off_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /activities/apps_detailed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_detailed_activities_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"apps_detailed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/activities/apps_detailed(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_detailed_organization_activities_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"apps_detailed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /clients/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_client_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/archive_dialog(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_dialog_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /job_sites/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_job_site_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_sites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/projects/archive_multiple_dialog(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_multiple_dialog_organization_projects_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"archive_multiple_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/clients/archive_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_multiple_organization_clients_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"archive_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/projects/archive_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_multiple_organization_projects_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"archive_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_break_policies/:id/archive(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_organization_work_break_policy_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_break_policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_orders/:id/archive(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_organization_work_order_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /overtime_policies/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_overtime_policy_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"overtime_policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /time_off_policies/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_time_off_policy_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"time_off_policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/clients/archived(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archived_organization_clients_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"archived"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/projects/archived(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archived_organization_projects_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"archived"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/time_off/archived(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archived_organization_time_off_policies_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"time_off"],[2,[7,"/"],[2,[6,"archived"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/archived(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archived_organizations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"archived"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /schedules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attendance_schedule_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_failure_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"failure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/slack/auth(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_organization_slack_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /auth_payment/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth_payment"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth_payment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_payments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth_payment"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /auth/success(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/asana(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_asana_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"asana"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/bamboo_hr(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_bamboo_hr_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"bamboo_hr"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/click_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_click_up_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"click_up"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/deel_hris(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_deel_hris_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"deel_hris"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/freshbooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_freshbooks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"freshbooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/freshbooks2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_freshbooks2_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"freshbooks2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/github(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_github_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"github"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/gitlab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_gitlab_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"gitlab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/gitlab_self_hosted(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_gitlab_self_hosted_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"gitlab_self_hosted"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/google_calendar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_google_calendar_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"google_calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/google_collab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_google_collab_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"google_collab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/hubstaff_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_hubstaff_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"hubstaff_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/jira(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_jira_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"jira"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/mavenlink(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_mavenlink_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"mavenlink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/microsoft_collab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_microsoft_collab_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"microsoft_collab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/microsoft_outlook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_microsoft_outlook_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"microsoft_outlook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/monday(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_monday_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"monday"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/podio(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_podio_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"podio"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/quickbooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_quickbooks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"quickbooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/redbooth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_redbooth_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"redbooth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/salesforce(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_salesforce_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"salesforce"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/slack_collab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_slack_collab_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"slack_collab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/trello(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_trello_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"trello"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/zendesk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_zendesk_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"zendesk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/success/zoho_projects(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_success_zoho_projects_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[6,"zoho_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/authenticate(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authenticate_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"authenticate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/amounts_owed(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_amounts_owed_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"amounts_owed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/apps_and_urls(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_apps_and_urls_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"apps_and_urls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/attendance(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_attendance_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"attendance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/audit_logs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_audit_logs_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"audit_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/client_budgets(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_client_budgets_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"client_budgets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/client_invoices_aging(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_client_invoices_aging_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"client_invoices_aging"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/client_invoices(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_client_invoices_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"client_invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/custom_time_and_activities(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_custom_time_and_activities_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"custom_time_and_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/daily_limits(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_daily_limits_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"daily_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/daily(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_daily_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"daily"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/:organization_id(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_dashboard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"organization_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/expenses(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_expenses_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"expenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/job_attendance(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_job_attendance_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"job_attendance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/job_sites(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_job_sites_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"job_sites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/manual_time_log(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_manual_time_log_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"manual_time_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/amounts_owed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_amounts_owed_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"amounts_owed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/apps_and_urls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_apps_and_urls_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"apps_and_urls"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/attendance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_attendance_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"attendance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/audit_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_audit_logs_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"audit_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/client_budgets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_client_budgets_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"client_budgets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/client_invoices_aging(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_client_invoices_aging_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"client_invoices_aging"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/client_invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_client_invoices_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"client_invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/custom_time_and_activities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_custom_time_and_activities_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"custom_time_and_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/daily_limits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_daily_limits_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"daily_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/daily(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_daily_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"daily"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/expenses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_expenses_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"expenses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/job_attendance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_job_attendance_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"job_attendance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/job_sites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_job_sites_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"job_sites"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/manual_time_log(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_manual_time_log_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"manual_time_log"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_payments_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/project_budgets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_project_budgets_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"project_budgets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/team_invoices_aging(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_team_invoices_aging_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team_invoices_aging"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/team_invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_team_invoices_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team_invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/time_and_activities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_time_and_activities_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"time_and_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/time_off_balances(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_time_off_balances_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"time_off_balances"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/time_off_transactions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_time_off_transactions_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"time_off_transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/timesheets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_timesheets_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"timesheets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/weekly_limits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_weekly_limits_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"weekly_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/work_breaks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_work_breaks_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"work_breaks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/work_sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_old_work_sessions_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"work_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/payments(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_payments_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/project_budgets(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_project_budgets_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"project_budgets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team_invoices_aging(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_team_invoices_aging_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_invoices_aging"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team_invoices(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_team_invoices_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/time_and_activities(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_time_and_activities_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_and_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/time_off_balances(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_time_off_balances_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_off_balances"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/time_off_transactions(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_time_off_transactions_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_off_transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/timesheets(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_timesheets_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"timesheets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/timer_apps/auto_track(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_track_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"timer_apps"],[2,[7,"/"],[2,[6,"auto_track"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/weekly_limits(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_weekly_limits_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"weekly_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/work_breaks(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_work_breaks_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_breaks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/work_sessions(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_work_sessions_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_entries/batch_approve_manual_time_requests(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_approve_manual_time_requests_organization_time_entries_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"batch_approve_manual_time_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/invite_links/batch_delete(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_delete_organization_invite_links_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"invite_links"],[2,[7,"/"],[2,[6,"batch_delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/manual_time_requests/batch_deny(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_deny_organization_manual_time_requests_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"manual_time_requests"],[2,[7,"/"],[2,[6,"batch_deny"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/invite_links/batch_disable(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_disable_organization_invite_links_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"invite_links"],[2,[7,"/"],[2,[6,"batch_disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/invite_links/batch_enable(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_enable_organization_invite_links_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"invite_links"],[2,[7,"/"],[2,[6,"batch_enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/projects/batch_update(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_update_organization_projects_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"batch_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/manual_time_requests/batch_update_status_dialog(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_update_status_dialog_organization_manual_time_requests_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"manual_time_requests"],[2,[7,"/"],[2,[6,"batch_update_status_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/activities/benchmarks_dialog(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const benchmarks_dialog_organization_activities_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"benchmarks_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/activities/benchmarks(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const benchmarks_organization_activities_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"benchmarks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/billing(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_redirect_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/:id/billing(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/custom_report_schedules/biweekly_start_options(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const biweekly_start_options_organization_custom_report_schedules_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"custom_report_schedules"],[2,[7,"/"],[2,[6,"biweekly_start_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /scheduled_reports/biweekly_start_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const biweekly_start_options_scheduled_reports_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"scheduled_reports"],[2,[7,"/"],[2,[6,"biweekly_start_options"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /features/block_feature_banner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const block_feature_banner_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[6,"block_feature_banner"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /promos/block_payroll_banner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const block_payroll_banner_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"promos"],[2,[7,"/"],[2,[6,"block_payroll_banner"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reviews/block_review_prompt(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const block_review_prompt_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[6,"block_review_prompt"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_payments/bonus(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bonus_organization_team_payments_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[6,"bonus"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/budget_detail(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const budget_detail_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"budget_detail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/schedules/bulk_create(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_create_organization_attendance_schedules_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[6,"bulk_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/holidays/bulk_create(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_create_organization_holidays_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"holidays"],[2,[7,"/"],[2,[6,"bulk_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/invites/bulk_create(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_create_organization_invites_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[6,"bulk_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/schedules/bulk_destroy(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_destroy_organization_attendance_schedules_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[6,"bulk_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/adjustments/bulk_members_preview(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_members_preview_organization_adjustment_policies_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[6,"bulk_members_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/adjustments/:id/bulk_members_preview(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_members_preview_organization_adjustment_policy_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bulk_members_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/adjustments/bulk_members_template(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_members_template_organization_adjustment_policies_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[6,"bulk_members_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/adjustments/:id/bulk_members_template(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_members_template_organization_adjustment_policy_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bulk_members_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_entries/calendar(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendar_organization_time_entries_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/schedules/calendar_resources(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendar_resources_organization_attendance_schedules_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[6,"calendar_resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/wizards/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const callback_integration_wizard_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizards"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/cancel_subscription(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_subscription_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/financials/cash_flow(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cash_flow_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"financials"],[2,[7,"/"],[2,[6,"cash_flow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/change_plan(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_plan_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:team_id/members/:id/change_role(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_role_team_team_member_path = /*#__PURE__*/ __route({"team_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_role"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_projects/:id/change_role(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_role_user_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_role"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_and_activities_reports/chart(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chart_organization_time_and_activities_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_and_activities_reports"],[2,[7,"/"],[2,[6,"chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat_area/messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_area_messages_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"chat_area"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_off_policies/check_csv(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_csv_organization_time_off_policies_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_off_policies"],[2,[7,"/"],[2,[6,"check_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/job_sites/check(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_organization_job_sites_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"job_sites"],[2,[7,"/"],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_orders/check(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_organization_work_orders_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /time_entries/:id/check(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_time_entry_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /checkout(/:campaign_token)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_path = /*#__PURE__*/ __route({"campaign_token":{},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[1,[2,[7,"/"],[3,"campaign_token"]]],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /checkout(/:campaign_token)/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_login_path = /*#__PURE__*/ __route({"campaign_token":{},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[1,[2,[7,"/"],[3,"campaign_token"]]],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/choose_addon(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const choose_addon_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"choose_addon"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/choose_integration(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const choose_integration_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"choose_integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/choose_plan(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const choose_plan_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"choose_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /clients/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:id/close(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const close_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/client_invoices/close_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const close_multiple_organization_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"client_invoices"],[2,[7,"/"],[2,[6,"close_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_invoices/close_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const close_multiple_organization_user_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_invoices"],[2,[7,"/"],[2,[6,"close_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/I/:id/close(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const close_user_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"I"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations/:id/collect_industry(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collect_industry_organization_user_organization_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"collect_industry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations/:id/collect_occupation(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collect_occupation_organization_user_organization_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"collect_occupation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_orders/:work_order_id/jobs/:id/complete(.:format)
 * @param {any} organization_id
 * @param {any} work_order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_organization_work_order_job_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"work_order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/complete_setup(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_setup_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"complete_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/complete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate_app/computers_new/members/:user_id/popover(.:format)
 * @param {any} organization_id
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const computers_member_popover_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate_app"],[2,[7,"/"],[2,[6,"computers_new"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"popover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /overtime_policies/:id/archive_dialog_wired(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_archive_overtime_policy_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"overtime_policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive_dialog_wired"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/confirm_billing(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_billing_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/adjustments/:id/confirm_delete(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_delete_organization_adjustment_policy_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payment_notes/:id/confirm_delete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_delete_team_payment_note_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payment_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/manual_time_requests/:id/confirm_deletion(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_deletion_organization_manual_time_request_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"manual_time_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_deletion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/custom_reports/:id/confirm_destroy(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_destroy_organization_custom_report_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"custom_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /scheduled_reports/:id/confirm_destroy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_destroy_scheduled_report_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"scheduled_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/addons/confirm_disable(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_disable_organization_addons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[6,"confirm_disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/payer_accounts/confirm_enable_auto_pay(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_enable_auto_pay_organization_payer_accounts_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[6,"confirm_enable_auto_pay"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/confirm_manual_projects_sync(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_manual_projects_sync_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_manual_projects_sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/confirm_modify_time_allowed_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_modify_time_allowed_settings_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_modify_time_allowed_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/confirm_payment(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_payment_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/confirm_plan_with_seats(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_plan_with_seats_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_plan_with_seats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /overtime_policies/:id/restore_dialog_wired(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_restore_overtime_policy_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"overtime_policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore_dialog_wired"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/confirm_sync_integrations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_sync_integrations_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_sync_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:id/confirm_sync_users(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_sync_users_payer_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_sync_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:id/confirm_users(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_users_payer_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/connect_repositories(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connect_repositories_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"connect_repositories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/background_tasks/:id/consume(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consume_organization_background_task_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"background_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"consume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/insights/context_metadata(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const context_metadata_organization_insights_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"insights"],[2,[7,"/"],[2,[6,"context_metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/paid_addons/:addon_sym/continue_trial(.:format)
 * @param {any} organization_id
 * @param {any} addon_sym
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const continue_trial_organization_paid_addons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"addon_sym":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"paid_addons"],[2,[7,"/"],[2,[3,"addon_sym"],[2,[7,"/"],[2,[6,"continue_trial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate_app/computers(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_app_computers_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate_app"],[2,[7,"/"],[2,[6,"computers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate_app/computers/merge_confirm(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_app_computers_merge_confirm_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate_app"],[2,[7,"/"],[2,[6,"computers"],[2,[7,"/"],[2,[6,"merge_confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate_app/computers/merge_create(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_app_computers_merge_create_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate_app"],[2,[7,"/"],[2,[6,"computers"],[2,[7,"/"],[2,[6,"merge_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate_app/computers/merge_new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_app_computers_merge_new_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate_app"],[2,[7,"/"],[2,[6,"computers"],[2,[7,"/"],[2,[6,"merge_new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate_app/computers_new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_app_computers_new_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate_app"],[2,[7,"/"],[2,[6,"computers_new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate_app/computers_new/export.csv(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_app_computers_new_export_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"csv"}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate_app"],[2,[7,"/"],[2,[6,"computers_new"],[2,[7,"/"],[2,[6,"export"],[2,[8,"."],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate_app/computers_new/filters(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_app_computers_new_filters_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate_app"],[2,[7,"/"],[2,[6,"computers_new"],[2,[7,"/"],[2,[6,"filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate_app/computers_new/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_app_computers_new_members_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate_app"],[2,[7,"/"],[2,[6,"computers_new"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate_app/computers_new/merge(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_app_computers_new_merge_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate_app"],[2,[7,"/"],[2,[6,"computers_new"],[2,[7,"/"],[2,[6,"merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate_app/computers_new/merge_confirm(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_app_computers_new_merge_confirm_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate_app"],[2,[7,"/"],[2,[6,"computers_new"],[2,[7,"/"],[2,[6,"merge_confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate_app/computers_new/merge_create(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_app_computers_new_merge_create_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate_app"],[2,[7,"/"],[2,[6,"computers_new"],[2,[7,"/"],[2,[6,"merge_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate_app/computers_new/uninstall(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_app_computers_new_uninstall_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate_app"],[2,[7,"/"],[2,[6,"computers_new"],[2,[7,"/"],[2,[6,"uninstall"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate_app/computers_new/uninstall_confirm(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_app_computers_new_uninstall_confirm_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate_app"],[2,[7,"/"],[2,[6,"computers_new"],[2,[7,"/"],[2,[6,"uninstall_confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate_app/computers/uninstall_confirm(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_app_computers_uninstall_confirm_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate_app"],[2,[7,"/"],[2,[6,"computers"],[2,[7,"/"],[2,[6,"uninstall_confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate_app/computers/uninstall_new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_app_computers_uninstall_new_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate_app"],[2,[7,"/"],[2,[6,"computers"],[2,[7,"/"],[2,[6,"uninstall_new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /screens/count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const count_screens_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"screens"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/schedules/count_shifts(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const count_shifts_organization_attendance_schedules_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[6,"count_shifts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_payments/create_bonus(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_bonus_organization_team_payments_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[6,"create_bonus"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/client_invoices/create_check(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_check_organization_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"client_invoices"],[2,[7,"/"],[2,[6,"create_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_invoices/create_check(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_check_organization_user_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_invoices"],[2,[7,"/"],[2,[6,"create_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/remote_vs_office/network_defined_locations/:location_type/create_dialog_wired(.:format)
 * @param {any} organization_id
 * @param {any} location_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_dialog_wired_network_defined_locations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"location_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"remote_vs_office"],[2,[7,"/"],[2,[6,"network_defined_locations"],[2,[7,"/"],[2,[3,"location_type"],[2,[7,"/"],[2,[6,"create_dialog_wired"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/create_in_tasks(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_in_tasks_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_in_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_organization_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/payer_accounts/:id/create_payees(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_payees_organization_payer_account_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_payees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/sso(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_sso_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_payments/create_timesheets(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_timesheets_organization_team_payments_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[6,"create_timesheets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/created_in_tasks(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const created_in_tasks_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"created_in_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/client_invoices/csv(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csv_organization_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"client_invoices"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_invoices/csv(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csv_organization_user_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_invoices"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/insights/cta_dialog(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cta_dialog_organization_insights_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"insights"],[2,[7,"/"],[2,[6,"cta_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/smart_notification_rules/cta_dialog(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cta_dialog_organization_smart_notification_rules_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"smart_notification_rules"],[2,[7,"/"],[2,[6,"cta_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/payee_accounts/currencies(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const currencies_organization_payee_accounts_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[6,"currencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:payer_account_id/payee_accounts/currencies(.:format)
 * @param {any} payer_account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const currencies_payer_account_payee_accounts_path = /*#__PURE__*/ __route({"payer_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"payer_account_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[6,"currencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/customized_reports(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customized_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"customized_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_entries/daily_export(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const daily_export_organization_time_entries_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"daily_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_entries/daily(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const daily_organization_time_entries_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"daily"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /referral/:organization_id/data(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_referral_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"referral"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/define_primary_integration_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const define_primary_integration_modal_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"define_primary_integration_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /activities/delete_activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_activity_activities_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"delete_activity"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/delete_dialog(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_dialog_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/remote_vs_office/network_defined_locations/:id/delete_dialog_wired(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_dialog_wired_network_defined_location_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"remote_vs_office"],[2,[7,"/"],[2,[6,"network_defined_locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_dialog_wired"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /screens/:id/delete_shot(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_shot_screen_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"screens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_shot"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /screens/delete_shots(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_shots_screens_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"screens"],[2,[7,"/"],[2,[6,"delete_shots"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/sso(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_sso_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/deleted(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleted_organizations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"deleted"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /timesheets/:id/deny_dialog(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deny_dialog_timesheet_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deny_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/manual_time_requests/:id/deny(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deny_organization_manual_time_request_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"manual_time_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deny"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /time_off_requests/:id/deny(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deny_time_off_request_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"time_off_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deny"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /payee_accounts/:id/method/:entry_method(.:format)
 * @param {any} id
 * @param {any} entry_method
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_method_payee_account_path = /*#__PURE__*/ __route({"id":{"r":true},"entry_method":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"method"],[2,[7,"/"],[2,[3,"entry_method"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invites/destroy_multiple(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_multiple_invites_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[6,"destroy_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/client_invoices/destroy_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_multiple_organization_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"client_invoices"],[2,[7,"/"],[2,[6,"destroy_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/teams/destroy_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_multiple_organization_teams_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"destroy_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_invoices/destroy_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_multiple_organization_user_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_invoices"],[2,[7,"/"],[2,[6,"destroy_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations/destroy_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_multiple_organization_user_organizations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[6,"destroy_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:team_id/members/destroy_multiple(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_multiple_team_team_members_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"destroy_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:team_id/projects/destroy_multiple(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_multiple_team_team_projects_path = /*#__PURE__*/ __route({"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"destroy_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/destroy_multiple_teams(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_multiple_teams_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_multiple_teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:team_id/projects/:id/destroy_team(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_team_team_project_path = /*#__PURE__*/ __route({"team_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_team"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/manual_time_requests/:id/destroy_wired(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_wired_organization_manual_time_request_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"manual_time_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_wired"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /timesheets/:id/details_dialog(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_dialog_timesheet_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/billing/invoices/details(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_organization_stripe_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/enterprise/device_provisioning(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const device_provisioning_enterprise_settings_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[6,"device_provisioning"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/disable_2fa/:user_id(.:format)
 * @param {any} organization_id
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_2fa_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"disable_2fa"],[2,[7,"/"],[2,[3,"user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/disable_hris_user(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_hris_user_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable_hris_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/disable_hris_users(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_hris_users_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable_hris_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/disable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/disable_member_payment_accounts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_member_payment_accounts_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable_member_payment_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:id/disable_members(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_members_payer_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/paid_addons/:addon_sym/disable(.:format)
 * @param {any} organization_id
 * @param {any} addon_sym
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_organization_paid_addons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"addon_sym":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"paid_addons"],[2,[7,"/"],[2,[3,"addon_sym"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /payee_accounts/:id/disable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_payee_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/disable_retries(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_retries_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable_retries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scheduled_reports/:id/disable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_scheduled_report_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"scheduled_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations/disable_tracking_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_tracking_multiple_organization_user_organizations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[6,"disable_tracking_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/disable_tracking(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_tracking_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable_tracking"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/disconnect_repositories(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disconnect_repositories_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disconnect_repositories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/dismiss_advertisement(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismiss_advertisement_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"dismiss_advertisement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/dismiss_bamboo_hr_integration_banner(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismiss_bamboo_hr_integration_banner_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss_bamboo_hr_integration_banner"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/dismiss_custom_report_banner(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismiss_custom_report_banner_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"dismiss_custom_report_banner"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/dismiss_deel_hris_integration_banner(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismiss_deel_hris_integration_banner_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss_deel_hris_integration_banner"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/dismiss_dialog(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismiss_dialog_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /payee_accounts/:id/payment_integration_migration/dismiss(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismiss_payment_integration_migration_payee_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payment_integration_migration"],[2,[7,"/"],[2,[6,"dismiss"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/dismiss_plan_limits_banner(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismiss_plan_limits_banner_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss_plan_limits_banner"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /promos/dismiss_promo_banner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismiss_promo_banner_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"promos"],[2,[7,"/"],[2,[6,"dismiss_promo_banner"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/dismiss_promotion(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismiss_promotion_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss_promotion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reviews/dismiss_review_prompt(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismiss_review_prompt_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[6,"dismiss_review_prompt"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /download/:channel(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_channel_path = /*#__PURE__*/ __route({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"channel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /download/:channel/:platform(.:format)
 * @param {any} channel
 * @param {any} platform
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_channel_platform_path = /*#__PURE__*/ __route({"channel":{"r":true},"platform":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[3,"platform"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /download/:channel/:platform/:app_type(.:format)
 * @param {any} channel
 * @param {any} platform
 * @param {any} app_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_channel_platform_app_type_path = /*#__PURE__*/ __route({"channel":{"r":true},"platform":{"r":true},"app_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[3,"platform"],[2,[7,"/"],[2,[3,"app_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /download/corporate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_corporate_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"corporate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /download/corporate/:channel(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_corporate_channel_path = /*#__PURE__*/ __route({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[3,"channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /download/deploy/:platform/:artifact_type/:channel(.:format)
 * @param {any} platform
 * @param {any} artifact_type
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_corporate_mdm_path = /*#__PURE__*/ __route({"platform":{"r":true},"artifact_type":{"r":true},"channel":{"r":true,"d":"release"},"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"deploy"],[2,[7,"/"],[2,[3,"platform"],[2,[7,"/"],[2,[3,"artifact_type"],[2,[7,"/"],[2,[3,"channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /download/mobileconfig(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_corporate_mobileconfig_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"mobileconfig"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/enterprise/download_default_profile(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_default_profile_enterprise_settings_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"enterprise"],[2,[7,"/"],[2,[6,"download_default_profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /download/enterprise(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_enterprise_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"enterprise"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/download_members_migration_csv(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_members_migration_csv_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"download_members_migration_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /download/:platform(.:format)
 * @param {any} platform
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_platform_path = /*#__PURE__*/ __route({"platform":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"platform"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /download/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_release_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /download/:id/:type(.:format)
 * @param {any} id
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_release_artifact_path = /*#__PURE__*/ __route({"id":{"r":true},"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /download/:id/:type/corporate(.:format)
 * @param {any} id
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_release_artifact_corporate_path = /*#__PURE__*/ __route({"id":{"r":true},"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[6,"corporate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/duplicate_project_dialog(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_project_dialog_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate_project_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/duplicate_project(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_project_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate_project"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /schedules/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_attendance_schedule_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/edit_billing(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_billing_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /clients/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_client_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/remote_vs_office/network_defined_locations/:id/edit_dialog_wired(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_dialog_wired_network_defined_location_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"remote_vs_office"],[2,[7,"/"],[2,[6,"network_defined_locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_dialog_wired"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/edit_friendly_name(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_friendly_name_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_friendly_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /holidays/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_holiday_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"holidays"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invites/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_invite_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /time_off_policies/:id/edit_members(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_members_time_off_policy_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"time_off_policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations/edit_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_multiple_organization_user_organizations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[6,"edit_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/user_projects/edit_multiple(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_multiple_project_user_projects_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"user_projects"],[2,[7,"/"],[2,[6,"edit_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /notes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_note_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/adjustments/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_adjustment_policy_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/global_todos/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_global_todo_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"global_todos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/invite_links/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_invite_link_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"invite_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/paid_addons/edit(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_paid_addons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"paid_addons"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/payee_accounts/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_payee_account_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/payer_accounts/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_payer_account_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/teams/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_team_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/unusual_activities/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_unusual_activity_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"unusual_activities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_invoices/:user_invoice_id/invoice_payments/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} user_invoice_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_user_invoice_invoice_payment_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"user_invoice_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_invoices"],[2,[7,"/"],[2,[3,"user_invoice_id"],[2,[7,"/"],[2,[6,"invoice_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/wizard/:id/:step(.:format)
 * @param {any} id
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_wizard_path = /*#__PURE__*/ __route({"id":{"r":true},"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_orders/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_work_order_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_orders/:work_order_id/jobs/:id/edit(.:format)
 * @param {any} organization_id
 * @param {any} work_order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_work_order_job_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"work_order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_orders/:work_order_id/jobs/:job_id/wired_form/edit(.:format)
 * @param {any} organization_id
 * @param {any} work_order_id
 * @param {any} job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organization_work_order_job_wired_form_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"work_order_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"wired_form"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /overtime_policies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_overtime_policy_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"overtime_policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/edit_pay_period_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_pay_period_modal_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"edit_pay_period_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/adjustments/:id/edit_pay_period(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_pay_period_organization_adjustment_policy_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_pay_period"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/edit_pay_period(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_pay_period_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_pay_period"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations/edit_pay_periods_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_pay_periods_multiple_organization_user_organizations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[6,"edit_pay_periods_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/edit_pay_rate_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_pay_rate_modal_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"edit_pay_rate_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /payee_accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_payee_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /payee_default_accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_payee_default_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payee_default_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_payer_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:payer_account_id/payee_accounts/:id/edit(.:format)
 * @param {any} payer_account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_payer_account_payee_account_path = /*#__PURE__*/ __route({"payer_account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"payer_account_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/edit_payment_info(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_payment_info_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_payment_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /saved_report_filters/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_saved_report_filter_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"saved_report_filters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scheduled_reports/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_scheduled_report_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"scheduled_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_team_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payment_notes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_team_payment_note_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payment_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:team_id/projects/:id/edit(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_team_project_path = /*#__PURE__*/ __route({"team_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/edit_teams(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_teams_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /time_off_policies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_time_off_policy_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"time_off_policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /time_off_requests/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_time_off_request_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"time_off_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/I/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"I"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:user_organization_id/payee_accounts/:id/edit(.:format)
 * @param {any} user_organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_organization_payee_account_path = /*#__PURE__*/ __route({"user_organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"user_organization_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/payee_accounts/:id/edit(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_payee_account_path = /*#__PURE__*/ __route({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/payee_default_accounts/:id/edit(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_payee_default_account_path = /*#__PURE__*/ __route({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"payee_default_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/insights/eligible_for_extended_cancellation(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eligible_for_extended_cancellation_organization_insights_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"insights"],[2,[7,"/"],[2,[6,"eligible_for_extended_cancellation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/enable_auto_pay(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_auto_pay_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable_auto_pay"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/enable_hris_user(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_hris_user_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable_hris_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/enable_hris_users(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_hris_users_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable_hris_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/enable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/enable_member_payment_accounts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_member_payment_accounts_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable_member_payment_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:id/enable_members(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_members_payer_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /payee_accounts/:id/enable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_payee_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/enable_retries(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_retries_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable_retries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scheduled_reports/:id/enable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_scheduled_report_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"scheduled_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations/enable_tracking_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_tracking_multiple_organization_user_organizations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[6,"enable_tracking_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/enable_tracking(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_tracking_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable_tracking"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/insights/engagement_scores(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const engagement_scores_organization_insights_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"insights"],[2,[7,"/"],[2,[6,"engagement_scores"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/essentials_upgrade_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const essentials_upgrade_modal_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"essentials_upgrade_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/essentials_upgrade(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const essentials_upgrade_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"essentials_upgrade"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /schedules/:id/exclude_date(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exclude_date_attendance_schedule_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"exclude_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/export_dialog(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_dialog_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/export_file(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_file_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations/export_for_update(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_for_update_organization_user_organizations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[6,"export_for_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations/export_for_update_schema(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_for_update_schema_organization_user_organizations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[6,"export_for_update_schema"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/unusual_activities/export(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_organization_unusual_activities_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"unusual_activities"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/export(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/extend_trial(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const extend_trial_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"extend_trial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/paid_addons/:addon_sym/extend_trial(.:format)
 * @param {any} organization_id
 * @param {any} addon_sym
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const extend_trial_organization_paid_addons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"addon_sym":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"paid_addons"],[2,[7,"/"],[2,[3,"addon_sym"],[2,[7,"/"],[2,[6,"extend_trial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:id/failed_syncs(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const failed_syncs_payer_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"failed_syncs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth_payment/failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const failure_auth_payments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth_payment"],[2,[7,"/"],[2,[6,"failure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /faq(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const faq_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"faq"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/star(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const favorite_reports_star_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"star"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/unstar(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const favorite_reports_unstar_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"unstar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /file_imports/:id/fetch(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fetch_file_import_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"file_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"fetch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /file_imports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_imports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"file_imports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/payee_accounts/find_default(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_default_organization_payee_accounts_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[6,"find_default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat_area/messages/finish(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finish_chat_area_messages_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"chat_area"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"finish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billing/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fix_payment_info_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/paid_addons/:addon_sym/fourteen_days_insights_trial(.:format)
 * @param {any} organization_id
 * @param {any} addon_sym
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fourteen_days_insights_trial_organization_paid_addons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"addon_sym":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"paid_addons"],[2,[7,"/"],[2,[3,"addon_sym"],[2,[7,"/"],[2,[6,"fourteen_days_insights_trial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user/g2_review_redirect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const g2_review_redirect_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"g2_review_redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/gateway_instructions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gateway_instructions_payer_accounts_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[6,"gateway_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/timesheets/generate_timesheets(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_timesheets_organization_timesheets_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[6,"generate_timesheets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/:type(.:format)
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generic_dashboard_path = /*#__PURE__*/ __route({"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generic_integrations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/auto/:section(/:subsection)(.:format)
 * @param {any} section
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generic_organization_path = /*#__PURE__*/ __route({"section":{"r":true},"subsection":{},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"auto"],[2,[7,"/"],[2,[3,"section"],[2,[1,[2,[7,"/"],[3,"subsection"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/:setting_page(/:setting)(.:format)
 * @param {any} id
 * @param {any} setting_page
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generic_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"setting_page":{"r":true},"setting":{},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[3,"setting_page"],[2,[1,[2,[7,"/"],[3,"setting"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /getting_started/:organization_id(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const getting_started_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"getting_started"],[2,[7,"/"],[2,[3,"organization_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/paid_addons/:addon_sym/grant_for_free(.:format)
 * @param {any} organization_id
 * @param {any} addon_sym
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grant_for_free_organization_paid_addons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"addon_sym":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"paid_addons"],[2,[7,"/"],[2,[3,"addon_sym"],[2,[7,"/"],[2,[6,"grant_for_free"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_and_activities_reports/group_data(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const group_data_organization_time_and_activities_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_and_activities_reports"],[2,[7,"/"],[2,[6,"group_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /health_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const health_check_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"health_check"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /help(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"help"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /help/:topic(.:format)
 * @param {any} topic
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_topic_path = /*#__PURE__*/ __route({"topic":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[3,"topic"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /activities/hide_dialog(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hide_dialog_activities_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"hide_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/hide_setup_checklist(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hide_setup_checklist_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"hide_setup_checklist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /holidays/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const holiday_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"holidays"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/holidays(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const holidays_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"holidays"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/hs_tasks_synced(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hs_tasks_synced_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"hs_tasks_synced"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hubstaff_auth_account_sync_endpoint_path = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"account"]]);

/**
 * Generates rails route to
 * /icalendar/:signature(.:format)
 * @param {any} signature
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const icalendar_path = /*#__PURE__*/ __route({"signature":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"icalendar"],[2,[7,"/"],[2,[3,"signature"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /activities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const index_activities_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"activities"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /integrations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:integration_id/integration_links/:id(.:format)
 * @param {any} integration_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integration_integration_link_path = /*#__PURE__*/ __route({"integration_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_id"],[2,[7,"/"],[2,[6,"integration_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:integration_id/integration_links(.:format)
 * @param {any} integration_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integration_integration_links_path = /*#__PURE__*/ __route({"integration_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_id"],[2,[7,"/"],[2,[6,"integration_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/integrations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/integrations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invites/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invite_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:id/invite_members(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invite_members_payer_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invite_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/invites(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invites_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:id/invites(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invites_team_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/client_invoices/invoice_action_check(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_action_check_organization_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"client_invoices"],[2,[7,"/"],[2,[6,"invoice_action_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_invoices/invoice_action_check(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_action_check_organization_user_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_invoices"],[2,[7,"/"],[2,[6,"invoice_action_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:unique_hash_token(.:format)
 * @param {any} unique_hash_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_as_client_path = /*#__PURE__*/ __route({"unique_hash_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"unique_hash_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:unique_hash_token/create_paypal_order(.:format)
 * @param {any} unique_hash_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_create_paypal_order_path = /*#__PURE__*/ __route({"unique_hash_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"unique_hash_token"],[2,[7,"/"],[2,[6,"create_paypal_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:invoice_id/invoice_payments/:id(.:format)
 * @param {any} invoice_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_invoice_payment_path = /*#__PURE__*/ __route({"invoice_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[2,[6,"invoice_payments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:invoice_id/invoice_payments(.:format)
 * @param {any} invoice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_invoice_payments_path = /*#__PURE__*/ __route({"invoice_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[2,[6,"invoice_payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:unique_hash_token/pdf(.:format)
 * @param {any} unique_hash_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_pdf_as_client_path = /*#__PURE__*/ __route({"unique_hash_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"unique_hash_token"],[2,[7,"/"],[2,[6,"pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:unique_hash_token/printed(.:format)
 * @param {any} unique_hash_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_printed_as_client_path = /*#__PURE__*/ __route({"unique_hash_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"unique_hash_token"],[2,[7,"/"],[2,[6,"printed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:unique_hash_token/record_payment(.:format)
 * @param {any} unique_hash_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_record_payment_path = /*#__PURE__*/ __route({"unique_hash_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"unique_hash_token"],[2,[7,"/"],[2,[6,"record_payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/invoices(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/invoicing(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoicing_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invoicing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth_payment/ipn_event(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ipn_event_auth_payments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth_payment"],[2,[7,"/"],[2,[6,"ipn_event"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /job_sites/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_site_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_sites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/:id/lead_emails(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lead_emails_team_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lead_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:id/lead_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lead_settings_team_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lead_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /learn_more/:product(/:id)(.:format)
 * @param {any} product
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const learn_more_path = /*#__PURE__*/ __route({"product":{"r":true},"id":{},"format":{}}, [2,[7,"/"],[2,[6,"learn_more"],[2,[7,"/"],[2,[3,"product"],[2,[1,[2,[7,"/"],[3,"id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/paid_addons/:addon_sym/learn_more_dialog(.:format)
 * @param {any} organization_id
 * @param {any} addon_sym
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const learn_more_dialog_organization_paid_addons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"addon_sym":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"paid_addons"],[2,[7,"/"],[2,[3,"addon_sym"],[2,[7,"/"],[2,[6,"learn_more_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reviews/leave_review(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leave_review_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[6,"leave_review"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/adjustments/legacy(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacy_organization_adjustment_policies_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[6,"legacy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/legacy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacy_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"legacy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/link_collaborators(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_collaborators_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link_collaborators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/link_dialog(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_dialog_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/link(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/link_organization(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_organization_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link_organization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/link(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/link_projects(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_projects_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/link_projects(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_projects_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/link_repositories(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_repositories_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link_repositories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:id/link(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_team_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/link_tenant(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_tenant_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link_tenant"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/link_time_off_policies(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_time_off_policies_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link_time_off_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/link_user_notification(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_user_notification_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link_user_notification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/link_users(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_users_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/linkable_organizations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkable_organizations_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"linkable_organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/linkable_projects(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkable_projects_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"linkable_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/schedules/lists(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lists_organization_attendance_schedules_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[6,"lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /activities/locations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locations_activities_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"locations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/activities/locations(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locations_organization_activities_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /login_now(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_now_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"login_now"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /login/token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_web_token_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"login"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /zone/lookbook
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_path = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"zone"],[2,[7,"/"],[6,"lookbook"]]]]);

/**
 * Generates rails route to
 * /zone/lookbook/embed/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_embed_path = /*#__PURE__*/ __route({"path":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"zone"],[2,[7,"/"],[6,"lookbook"]]]],[7,"/"]],[2,[6,"embed"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /zone/lookbook/embed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_embed_lookup_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"zone"],[2,[7,"/"],[6,"lookbook"]]]],[7,"/"]],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /zone/lookbook/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_home_path = /*#__PURE__*/ __route({}, [2,[2,[7,"/"],[2,[6,"zone"],[2,[7,"/"],[6,"lookbook"]]]],[7,"/"]]);

/**
 * Generates rails route to
 * /zone/lookbook/inspect/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_inspect_path = /*#__PURE__*/ __route({"path":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"zone"],[2,[7,"/"],[6,"lookbook"]]]],[7,"/"]],[2,[6,"inspect"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /zone/lookbook/pages/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_page_path = /*#__PURE__*/ __route({"path":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"zone"],[2,[7,"/"],[6,"lookbook"]]]],[7,"/"]],[2,[6,"pages"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /zone/lookbook/pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_page_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"zone"],[2,[7,"/"],[6,"lookbook"]]]],[7,"/"]],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /zone/lookbook/preview/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_preview_path = /*#__PURE__*/ __route({"path":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"zone"],[2,[7,"/"],[6,"lookbook"]]]],[7,"/"]],[2,[6,"preview"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /zone/lookbook/previews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_previews_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"zone"],[2,[7,"/"],[6,"lookbook"]]]],[7,"/"]],[2,[6,"previews"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/manage_backup_integration_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_backup_integration_modal_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"manage_backup_integration_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /clients/:id/manage_budget(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_budget_client_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manage_budget"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/manage_budget(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_budget_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manage_budget"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations/manage_daily_limit_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_daily_limit_multiple_organization_user_organizations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[6,"manage_daily_limit_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/manage_limits(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_limits_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manage_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invites/:id/manage_pay_rate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_pay_rate_invite_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manage_pay_rate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invites/manage_pay_rate_multiple(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_pay_rate_multiple_invites_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[6,"manage_pay_rate_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_projects/manage_pay_rate_multiple(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_pay_rate_multiple_user_projects_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user_projects"],[2,[7,"/"],[2,[6,"manage_pay_rate_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_projects/:id/manage_pay_rate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_pay_rate_user_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manage_pay_rate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/manage_policies(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_policies_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manage_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/manage_policy_modal/:policy(.:format)
 * @param {any} id
 * @param {any} policy
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_policy_modal_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"policy":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"manage_policy_modal"],[2,[7,"/"],[2,[3,"policy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/manage_projects(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_projects_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manage_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invites/:id/manage_teams(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_teams_invite_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manage_teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/manage_teams(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_teams_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manage_teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invites/:id/manage_weekly_limit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_weekly_limit_invite_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manage_weekly_limit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invites/manage_weekly_limit_multiple(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_weekly_limit_multiple_invites_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[6,"manage_weekly_limit_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations/manage_weekly_limit_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_weekly_limit_multiple_organization_user_organizations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[6,"manage_weekly_limit_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations/managers(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const managers_organization_user_organizations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[6,"managers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/manual_pay(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manual_pay_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manual_pay"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/unusual_activities/mark_all_as_reviewed(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_all_as_reviewed_organization_unusual_activities_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"unusual_activities"],[2,[7,"/"],[2,[6,"mark_all_as_reviewed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/remote_vs_office/network_defined_locations/:id/mark_as_non_office(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_non_office_network_defined_location_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"remote_vs_office"],[2,[7,"/"],[2,[6,"network_defined_locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_non_office"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/remote_vs_office/network_defined_locations/:id/mark_as_non_office_wired(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_non_office_wired_network_defined_location_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"remote_vs_office"],[2,[7,"/"],[2,[6,"network_defined_locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_non_office_wired"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/receivers/:user_id/mark_as_paid_dialog(.:format)
 * @param {any} id
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_paid_dialog_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"receivers"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"mark_as_paid_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/receivers/:user_id/mark_as_paid(.:format)
 * @param {any} id
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_paid_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"receivers"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"mark_as_paid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/unusual_activities/:user_id/mark_as_reviewed(.:format)
 * @param {any} organization_id
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_reviewed_organization_unusual_activities_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"unusual_activities"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"mark_as_reviewed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:id/mark_as_sent(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_sent_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_sent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/I/:id/mark_as_sent(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_sent_user_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"I"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_sent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/mark_demo_viewed(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_demo_viewed_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"mark_demo_viewed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate/ignored_user_patterns/:id/matches(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const matches_organization_corporate_ignored_user_pattern_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"ignored_user_patterns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"matches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/:organization_id/me(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const me_dashboard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"me"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/invites/member_create(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const member_create_organization_invites_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[6,"member_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/email_notifications(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const member_notification_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"email_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_entries/member_panel(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const member_panel_organization_time_entries_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"member_panel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_entries/member_panels(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const member_panels_organization_time_entries_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"member_panels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/member_payment_accounts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const member_payment_accounts_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"member_payment_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/members(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const member_profiles_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/:organization_id/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_dashboard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/holidays/members_data(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_data_organization_holidays_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"holidays"],[2,[7,"/"],[2,[6,"members_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_off_policies/members_data(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_data_organization_time_off_policies_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_off_policies"],[2,[7,"/"],[2,[6,"members_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/adjustments/:id/members_dialog(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_dialog_organization_adjustment_policy_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"members_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /overtime_policies/:id/members_dialog_wired(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_dialog_wired_overtime_policy_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"overtime_policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"members_dialog_wired"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/members_dropdown(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_dropdown_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"members_dropdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_payments/members_dropdown(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_dropdown_organization_team_payments_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[6,"members_dropdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_off_requests/members_dropdown(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_dropdown_organization_time_off_requests_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_off_requests"],[2,[7,"/"],[2,[6,"members_dropdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/timesheets/members_dropdown(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_dropdown_organization_timesheets_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[6,"members_dropdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /holidays/:id/members(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_holiday_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"holidays"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/members(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/members_list(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_list_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"members_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/activities/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_organization_activities_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/adjustments/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_organization_adjustment_policies_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/schedules/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_organization_attendance_schedules_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/insights/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_organization_insights_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"insights"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/manual_time_requests/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_organization_manual_time_requests_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"manual_time_requests"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/payee_accounts/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_organization_payee_accounts_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/projects/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_organization_projects_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/smart_notification_rules/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_organization_smart_notification_rules_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"smart_notification_rules"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/teams/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_organization_teams_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_entries/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_organization_time_entries_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_off_requests/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_organization_time_off_requests_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_off_requests"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/timesheets/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_organization_timesheets_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_break_policies/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_organization_work_break_policies_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_break_policies"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:id/members(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_payer_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:payer_account_id/payee_accounts/members(.:format)
 * @param {any} payer_account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_payer_account_payee_accounts_path = /*#__PURE__*/ __route({"payer_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"payer_account_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/setup/members(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"setup"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /time_off_policies/:id/members(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_time_off_policy_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"time_off_policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/schedules/members_without_shifts(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_without_shifts_organization_attendance_schedules_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[6,"members_without_shifts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/merge_members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const merge_members_index_organization_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"merge_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/2fa(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mfa_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"2fa"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/payer_accounts/:id/migrate(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const migrate_organization_payer_account_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"migrate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /activities/move_activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_activity_activities_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"move_activity"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /activities/move_activity_dialog(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_activity_dialog_activities_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"move_activity_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/paid_addons/multiple_upsell_dialog(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multiple_upsell_dialog_organization_paid_addons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"paid_addons"],[2,[7,"/"],[2,[6,"multiple_upsell_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/amounts_owed(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_amounts_owed_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"amounts_owed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/apps_and_urls(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_apps_and_urls_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"apps_and_urls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/attendance(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_attendance_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"attendance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/custom_time_and_activities(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_custom_time_and_activities_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"custom_time_and_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/daily_chart(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_daily_chart_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"daily_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/daily_limits(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_daily_limits_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"daily_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/daily(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_daily_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"daily"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/expenses(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_expenses_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"expenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/job_attendance(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_job_attendance_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"job_attendance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/job_sites(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_job_sites_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"job_sites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/manual_time_log(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_manual_time_log_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"manual_time_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/amounts_owed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_amounts_owed_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"amounts_owed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/apps_and_urls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_apps_and_urls_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"apps_and_urls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/attendance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_attendance_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"attendance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/custom_time_and_activities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_custom_time_and_activities_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"custom_time_and_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/daily_limits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_daily_limits_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"daily_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/daily(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_daily_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"daily"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/expenses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_expenses_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"expenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/job_attendance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_job_attendance_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"job_attendance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/job_sites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_job_sites_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"job_sites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/manual_time_log(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_manual_time_log_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"manual_time_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_payments_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/team_invoices_aging(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_team_invoices_aging_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"team_invoices_aging"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/team_invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_team_invoices_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"team_invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/time_and_activities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_time_and_activities_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"time_and_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/time_off_balances(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_time_off_balances_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"time_off_balances"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/time_off_transactions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_time_off_transactions_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"time_off_transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/timesheets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_timesheets_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"timesheets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/weekly_limits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_weekly_limits_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"weekly_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/work_breaks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_work_breaks_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"work_breaks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/my/work_sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_old_work_sessions_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"work_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/payments(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_payments_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/team_invoices_aging(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_team_invoices_aging_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"team_invoices_aging"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/team_invoices(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_team_invoices_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"team_invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/time_and_activities(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_time_and_activities_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"time_and_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/time_off_balances(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_time_off_balances_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"time_off_balances"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/time_off_transactions(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_time_off_transactions_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"time_off_transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/timesheets(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_timesheets_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"timesheets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/weekly_limits(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_weekly_limits_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"weekly_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/work_breaks(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_work_breaks_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"work_breaks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/my/work_sessions(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_work_sessions_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[6,"work_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/navigate_to_settings_page(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const navigate_to_settings_page_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"navigate_to_settings_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/:organization_id/needs_review/:dashboard_type(.:format)
 * @param {any} organization_id
 * @param {any} dashboard_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const needs_review_dashboard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"dashboard_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"needs_review"],[2,[7,"/"],[2,[3,"dashboard_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/remote_vs_office/network_defined_locations/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_defined_location_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"remote_vs_office"],[2,[7,"/"],[2,[6,"network_defined_locations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/remote_vs_office/network_defined_locations(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const network_defined_locations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"remote_vs_office"],[2,[7,"/"],[2,[6,"network_defined_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:integration_id/integration_links/new(.:format)
 * @param {any} integration_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_integration_integration_link_path = /*#__PURE__*/ __route({"integration_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"integration_id"],[2,[7,"/"],[2,[6,"integration_links"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:invoice_id/invoice_payments/new(.:format)
 * @param {any} invoice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_invoice_invoice_payment_path = /*#__PURE__*/ __route({"invoice_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[2,[6,"invoice_payments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /notes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_note_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/adjustments/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_adjustment_policy_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/batch_manual_time_entries/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_batch_manual_time_entry_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"batch_manual_time_entries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/clients/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_client_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/custom_report_schedules/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_custom_report_schedule_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"custom_report_schedules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/exports/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_export_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/holidays/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_holiday_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"holidays"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_integration_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/invites/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_invite_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/invite_links/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_invite_link_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"invite_links"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/client_invoices/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_invoice_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"client_invoices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/paid_addons/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_paid_addons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"paid_addons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/payee_accounts/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_payee_account_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/payer_accounts/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_payer_account_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/projects/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_project_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/slack/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_slack_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/teams/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_team_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_payments/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_team_payment_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_and_activities_reports/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_time_and_activities_report_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_and_activities_reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_off_policies/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_time_off_policy_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_off_policies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_off_requests/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_time_off_request_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_off_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/unusual_activities/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_unusual_activity_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"unusual_activities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_invoices/new(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_user_invoice_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_invoices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_invoices/:user_invoice_id/invoice_payments/new(.:format)
 * @param {any} organization_id
 * @param {any} user_invoice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_user_invoice_invoice_payment_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"user_invoice_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_invoices"],[2,[7,"/"],[2,[3,"user_invoice_id"],[2,[7,"/"],[2,[6,"invoice_payments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_orders/:work_order_id/wired/new(.:format)
 * @param {any} organization_id
 * @param {any} work_order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organization_work_order_wired_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"work_order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"wired"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /overtime_policies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_overtime_policy_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"overtime_policies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:payer_account_id/payee_accounts/new(.:format)
 * @param {any} payer_account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_payer_account_payee_account_path = /*#__PURE__*/ __route({"payer_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"payer_account_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/I/:id/new_payment(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_payment_user_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"I"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"new_payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/new_product_link(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_product_link_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"new_product_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/global_todos/new(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_project_global_todo_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"global_todos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/new_redirect/:project_id(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_redirect_tasks_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"new_redirect"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /saved_report_filters/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_saved_report_filter_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"saved_report_filters"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scheduled_reports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_scheduled_report_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"scheduled_reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_task_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/:id/members/new(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_team_member_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:team_payment_id/team_payment_notes/new(.:format)
 * @param {any} team_payment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_team_payment_team_payment_note_path = /*#__PURE__*/ __route({"team_payment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"team_payment_id"],[2,[7,"/"],[2,[6,"team_payment_notes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:id/projects/new(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_team_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /time_entries/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_time_entry_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/new_transfer(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_transfer_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"new_transfer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/I/:user_invoice_id/invoice_payments/new(.:format)
 * @param {any} user_invoice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_invoice_invoice_payment_path = /*#__PURE__*/ __route({"user_invoice_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"I"],[2,[7,"/"],[2,[3,"user_invoice_id"],[2,[7,"/"],[2,[6,"invoice_payments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/payee_default_accounts/new(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_payee_default_account_path = /*#__PURE__*/ __route({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"payee_default_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_orders/next_number(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const next_number_organization_work_orders_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"next_number"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/next(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const next_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"next"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const note_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_break_policies/notifications(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifications_organization_work_break_policies_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_break_policies"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/notifications(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifications_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauths_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/invites/onboarding_status(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_status_organization_invites_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[6,"onboarding_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/projects/only_managers_can_complete_todos(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const only_managers_can_complete_todos_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"only_managers_can_complete_todos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/projects/only_managers_can_manage_todos(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const only_managers_can_manage_todos_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"only_managers_can_manage_todos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:id/open(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const open_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"open"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/client_invoices/open_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const open_multiple_organization_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"client_invoices"],[2,[7,"/"],[2,[6,"open_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_invoices/open_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const open_multiple_organization_user_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_invoices"],[2,[7,"/"],[2,[6,"open_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/I/:id/open(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const open_user_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"I"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"open"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /payee_accounts/:id/payment_integration_migration/opt_out(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opt_out_payment_integration_migration_payee_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payment_integration_migration"],[2,[7,"/"],[2,[6,"opt_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/activities(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_activities_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/addons(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_addons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"addons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/adjustments(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_adjustment_policies_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"adjustments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/adjustments/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_adjustment_policy_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/ai_manager(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ai_manager_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ai_manager"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/ai_manager/briefings/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ai_manager_briefing_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ai_manager"],[2,[7,"/"],[2,[6,"briefings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/ai_manager/briefings(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ai_manager_briefings_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ai_manager"],[2,[7,"/"],[2,[6,"briefings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/ai_manager/conversations/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ai_manager_conversation_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ai_manager"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/ai_manager/conversations/:conversation_id/messages(.:format)
 * @param {any} organization_id
 * @param {any} conversation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ai_manager_conversation_messages_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"conversation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ai_manager"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/ai_manager/conversations(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ai_manager_conversations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ai_manager"],[2,[7,"/"],[2,[6,"conversations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/ai_manager/credit_requests(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ai_manager_credit_requests_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ai_manager"],[2,[7,"/"],[2,[6,"credit_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/ai_manager/feed(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ai_manager_feed_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ai_manager"],[2,[7,"/"],[2,[6,"feed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/ai_manager/feed/items/:item_id/deep_dive(.:format)
 * @param {any} organization_id
 * @param {any} item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ai_manager_feed_item_deep_dive_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ai_manager"],[2,[7,"/"],[2,[6,"feed"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"item_id"],[2,[7,"/"],[2,[6,"deep_dive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/ai_manager/limits(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ai_manager_limits_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ai_manager"],[2,[7,"/"],[2,[6,"limits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/ai_manager/team_feed(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_ai_manager_team_feed_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ai_manager"],[2,[7,"/"],[2,[6,"team_feed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/api_tokens/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_api_token_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api_tokens"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/api_tokens(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_api_tokens_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"api_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/schedules(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_attendance_schedules_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/attendance_shifts/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_attendance_shift_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"attendance_shifts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/background_tasks/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_background_task_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"background_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/batch_manual_time_entries(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_batch_manual_time_entries_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"batch_manual_time_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/clients(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_clients_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"clients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate/ignored_user_patterns/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_corporate_ignored_user_pattern_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"ignored_user_patterns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate/ignored_user_patterns(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_corporate_ignored_user_patterns_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"ignored_user_patterns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate/ignored_users(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_corporate_ignored_users_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"ignored_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/custom_fields_settings(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_custom_fields_settings_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"custom_fields_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/custom_reports/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_custom_report_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"custom_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/custom_report_schedules(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_custom_report_schedules_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"custom_report_schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/custom_reports(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_custom_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"custom_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/daily_briefing(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_daily_briefing_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"daily_briefing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/download/corporate(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_download_corporate_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"corporate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/download/corporate/:channel(.:format)
 * @param {any} organization_id
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_download_corporate_channel_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[3,"channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/download/corporate/wizard_step(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_download_wizard_step_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"wizard_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/expenses/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_expense_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"expenses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/expenses(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_expenses_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"expenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/exports(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_exports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/getting_started(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_getting_started_index_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"getting_started"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/global_todos/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_global_todo_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"global_todos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/global_todos(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_global_todos_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"global_todos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/holidays(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_holidays_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"holidays"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/insights(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_insights_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"insights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/insights_cancellation_reasons(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_insights_cancellation_reasons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"insights_cancellation_reasons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/insights_onboarding(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_insights_onboarding_index_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"insights_onboarding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_integration_wizard_index_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/invite_links/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_invite_link_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"invite_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/invite_links(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_invite_links_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"invite_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/invites(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_invites_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"invites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/invoice_line_items/:invoice_type(.:format)
 * @param {any} organization_id
 * @param {any} invoice_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_invoice_line_item_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"invoice_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"invoice_line_items"],[2,[7,"/"],[2,[3,"invoice_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/invoice_line_items/:invoice_type/tasks(.:format)
 * @param {any} organization_id
 * @param {any} invoice_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_invoice_line_item_tasks_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"invoice_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"invoice_line_items"],[2,[7,"/"],[2,[3,"invoice_type"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/client_invoices(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"client_invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/job_sites(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_job_sites_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"job_sites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/manual_time_requests/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_manual_time_request_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"manual_time_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/manual_time_requests(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_manual_time_requests_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"manual_time_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/map/sites(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_map_sites_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"map"],[2,[7,"/"],[2,[6,"sites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/map/users(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_map_users_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"map"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/mcp(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_mcp_settings_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"mcp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/members/:user_id(.:format)
 * @param {any} organization_id
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_member_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_members_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/members_rate_status(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_members_rate_status_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"members_rate_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/invoice_line_items/new/:invoice_type(.:format)
 * @param {any} organization_id
 * @param {any} invoice_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_new_invoice_line_item_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"invoice_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"invoice_line_items"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"invoice_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/paid_addons(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_paid_addons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"paid_addons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/payee_accounts/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_payee_account_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/payee_accounts(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_payee_accounts_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/payer_accounts/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_payer_account_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/payer_accounts(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_payer_accounts_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payer_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/projects(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_projects_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/scheduled(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_scheduled_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"scheduled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/projects/global_todos(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_settings_global_todos_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"global_todos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/insights(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_settings_insights_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"insights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/organization(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"organization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/timer_apps/auto_track/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_settings_timer_apps_auto_track_members_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"timer_apps"],[2,[7,"/"],[2,[6,"auto_track"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/work_targets(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_settings_work_targets_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_targets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/shared_links(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_shared_links_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"shared_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/silent_app/how_it_works(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_silent_app_how_it_works_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"silent_app"],[2,[7,"/"],[2,[6,"how_it_works"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/slack(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_slack_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"slack"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/smart_notification_rules/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_smart_notification_rule_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"smart_notification_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/smart_notification_rules(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_smart_notification_rules_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"smart_notification_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/billing/invoices/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_stripe_invoice_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/billing/invoices(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_stripe_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/tasks(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_tasks_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/teams/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_team_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_payments(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_team_payments_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/teams(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_teams_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_and_activities_reports/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_time_and_activities_report_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_and_activities_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_and_activities_reports(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_time_and_activities_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_and_activities_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_entries(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_time_entries_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/time_off_balances(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_time_off_balances_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"time_off_balances"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_off_policies(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_time_off_policies_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_off_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_off_requests(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_time_off_requests_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_off_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/timesheets(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_timesheets_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"timesheets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/timesheets_panels(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_timesheets_panels_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"timesheets_panels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/unusual_activities(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_unusual_activities_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"unusual_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/unusual_activities/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_unusual_activity_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"unusual_activities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_invoices/:user_invoice_id/invoice_payments/:id(.:format)
 * @param {any} organization_id
 * @param {any} user_invoice_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_user_invoice_invoice_payment_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"user_invoice_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_invoices"],[2,[7,"/"],[2,[3,"user_invoice_id"],[2,[7,"/"],[2,[6,"invoice_payments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_invoices/:user_invoice_id/invoice_payments(.:format)
 * @param {any} organization_id
 * @param {any} user_invoice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_user_invoice_invoice_payments_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"user_invoice_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_invoices"],[2,[7,"/"],[2,[3,"user_invoice_id"],[2,[7,"/"],[2,[6,"invoice_payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_invoices(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_user_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_user_organizations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/wizard/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_wizard_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/wizard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_wizard_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"wizard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_break_policies(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_work_break_policies_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_break_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_break_policies/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_work_break_policy_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_break_policies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_orders/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_work_order_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_orders/:work_order_id/jobs/:id(.:format)
 * @param {any} organization_id
 * @param {any} work_order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_work_order_job_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"work_order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_orders/:work_order_id/job_schedules/:id(.:format)
 * @param {any} organization_id
 * @param {any} work_order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_work_order_job_schedule_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"work_order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"job_schedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_orders/:work_order_id/jobs/:job_id/wired_form(.:format)
 * @param {any} organization_id
 * @param {any} work_order_id
 * @param {any} job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_work_order_job_wired_form_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"work_order_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"wired_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_orders/:work_order_id/jobs/:job_id/wired_view_job(.:format)
 * @param {any} organization_id
 * @param {any} work_order_id
 * @param {any} job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_work_order_job_wired_view_job_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"work_order_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"wired_view_job"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_orders/:work_order_id/jobs(.:format)
 * @param {any} organization_id
 * @param {any} work_order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_work_order_jobs_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"work_order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_orders/:work_order_id/wired(.:format)
 * @param {any} organization_id
 * @param {any} work_order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_work_order_wired_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"work_order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"wired"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_orders(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_work_orders_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/auto/smart_notification_rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizations_auto_smart_notification_rules_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"auto"],[2,[7,"/"],[2,[6,"smart_notification_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /overtime_policies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overtime_policies_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"overtime_policies"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/overtime_policies(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overtime_policies_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"overtime_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /overtime_policies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overtime_policy_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"overtime_policies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/overtime(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overtime_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"overtime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /auth_payment/paid_success(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paid_success_auth_payments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth_payment"],[2,[7,"/"],[2,[6,"paid_success"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_payments/past/legacy(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const past_legacy_organization_team_payments_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[6,"past"],[2,[7,"/"],[2,[6,"legacy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_payments/past(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const past_organization_team_payments_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[6,"past"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/adjustments/pay_periods(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pay_periods_organization_adjustment_policies_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[6,"pay_periods"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/I/:id/pay(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pay_user_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"I"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pay"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /payee_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payee_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /payee_default_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payee_default_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payee_default_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payer_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:payer_account_id/payee_accounts/:id(.:format)
 * @param {any} payer_account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payer_account_payee_account_path = /*#__PURE__*/ __route({"payer_account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"payer_account_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:payer_account_id/payee_accounts(.:format)
 * @param {any} payer_account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payer_account_payee_accounts_path = /*#__PURE__*/ __route({"payer_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"payer_account_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auto/payment_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_accounts_redirect_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auto"],[2,[7,"/"],[2,[6,"payment_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/payment_accounts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_accounts_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payment_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/payment_events(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_events_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payment_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/payment_exports(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_exports_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payment_exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/payment_members_dropdown(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_members_dropdown_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payment_members_dropdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/payment_retry(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_retry_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payment_retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/payments(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/payment_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_status_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payment_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/payer_accounts/:id/payroll_setup_select_account(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payroll_setup_select_account_organization_payer_account_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll_setup_select_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:id/pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pdf_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/I/:id/pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pdf_user_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"I"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/pending_action_counts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pending_action_counts_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pending_action_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/invite/:org_invite_token(.:format)
 * @param {any} org_invite_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const per_org_invite_path = /*#__PURE__*/ __route({"org_invite_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"invite"],[2,[7,"/"],[2,[3,"org_invite_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invites/:token/accept(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const per_user_invite_path = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/insights/performance_csv(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const performance_csv_organization_insights_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"insights"],[2,[7,"/"],[2,[6,"performance_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/insights/performance_pdf(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const performance_pdf_organization_insights_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"insights"],[2,[7,"/"],[2,[6,"performance_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_entries/period(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const period_organization_time_entries_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"period"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/timesheets/periods_for_range(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const periods_for_range_organization_timesheets_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[6,"periods_for_range"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/:organization_id/pinnable_members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pinnable_members_dashboard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"pinnable_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/plan_change_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plan_change_status_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"plan_change_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/plan_details(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plan_details_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"plan_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/plan_limits(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plan_limits_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"plan_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/plans(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plans_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"plans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/poll_time_off_policies(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poll_time_off_policies_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"poll_time_off_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /login/success(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const post_login_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"login"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /s3/file_imports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const presign_file_imports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"s3"],[2,[7,"/"],[2,[6,"file_imports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /s3/invoice_logos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const presign_invoice_logos_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"s3"],[2,[7,"/"],[2,[6,"invoice_logos"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /s3/logos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const presign_logos_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"s3"],[2,[7,"/"],[2,[6,"logos"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /s3/manual_time_entry_request_attachments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const presign_manual_time_entry_request_attachments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"s3"],[2,[7,"/"],[2,[6,"manual_time_entry_request_attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /s3/receipts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const presign_receipts_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"s3"],[2,[7,"/"],[2,[6,"receipts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /s3/time_off_request_attachments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const presign_time_off_request_attachments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"s3"],[2,[7,"/"],[2,[6,"time_off_request_attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/corporate/ignored_user_patterns/preview_matches(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_matches_organization_corporate_ignored_user_patterns_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"corporate"],[2,[7,"/"],[2,[6,"ignored_user_patterns"],[2,[7,"/"],[2,[6,"preview_matches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /scheduled_reports/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_scheduled_reports_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"scheduled_reports"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/view_components/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_view_component_path = /*#__PURE__*/ __route({"path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"view_components"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/view_components(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_view_components_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"view_components"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/previous(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previous_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"previous"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/getting_started/previous_substep(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previous_substep_organization_getting_started_index_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"getting_started"],[2,[7,"/"],[2,[6,"previous_substep"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/insights_onboarding/previous_substep(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previous_substep_organization_insights_onboarding_index_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"insights_onboarding"],[2,[7,"/"],[2,[6,"previous_substep"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/pricing_product_switch(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pricing_product_switch_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pricing_product_switch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/product_links(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_links_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"product_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/global_todos/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_global_todo_path = /*#__PURE__*/ __route({"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"global_todos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/global_todos(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_global_todos_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"global_todos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/project_list(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_list_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"project_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/project_rates(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_rates_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"project_rates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/projects(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/projects_memberships(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_memberships_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"projects_memberships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/projects_options(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_options_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"projects_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/batch_manual_time_entries/projects(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_organization_batch_manual_time_entries_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"batch_manual_time_entries"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/clients/projects(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_organization_clients_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/global_todos/projects(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_organization_global_todos_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"global_todos"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_entries/projects(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_organization_time_entries_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/timesheets/projects(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_organization_timesheets_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations/projects(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_organization_user_organizations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/proof_of_payment/:user_id(.:format)
 * @param {any} id
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proof_of_payment_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"proof_of_payment"],[2,[7,"/"],[2,[3,"user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/provider_connect_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const provider_connect_modal_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"provider_connect_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/provider_create_basic_auth(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const provider_create_basic_auth_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"provider_create_basic_auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/provider_edit_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const provider_edit_modal_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"provider_edit_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/provider_update_basic_auth(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const provider_update_basic_auth_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"provider_update_basic_auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /purchase(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchase_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"purchase"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/paid_addons/:addon_sym/purchase(.:format)
 * @param {any} organization_id
 * @param {any} addon_sym
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchase_organization_paid_addons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"addon_sym":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"paid_addons"],[2,[7,"/"],[2,[3,"addon_sym"],[2,[7,"/"],[2,[6,"purchase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/reauth(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reauth_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reauth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/reauth_token(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reauth_token_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reauth_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/receipts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receipts_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"receipts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/record_cancelation_attempt(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const record_cancelation_attempt_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"record_cancelation_attempt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/redirect(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const redirect_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /referral(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referral_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"referral"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/billing/invoices/refresh_details(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_details_organization_stripe_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"refresh_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_and_activities_reports/refresh_filters(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_filters_organization_time_and_activities_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_and_activities_reports"],[2,[7,"/"],[2,[6,"refresh_filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /checkout/refresh_intent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_intent_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"refresh_intent"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/refresh_members(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_members_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refresh_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/batch_manual_time_entries/refresh_modal(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_modal_organization_batch_manual_time_entries_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"batch_manual_time_entries"],[2,[7,"/"],[2,[6,"refresh_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/remap_user(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remap_user_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remap_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /payee_accounts/:id/remind_member_setup(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remind_member_setup_payee_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remind_member_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/reminder_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reminder_modal_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"reminder_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/remote_users(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remote_users_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remote_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:id/remote_users(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remote_users_payer_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remote_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/remote_vs_office/non_office_locations(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remote_vs_office_non_office_locations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"remote_vs_office"],[2,[7,"/"],[2,[6,"non_office_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/remote_vs_office/office_locations(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remote_vs_office_office_locations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"remote_vs_office"],[2,[7,"/"],[2,[6,"office_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /clients/:id/remove_budget(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_budget_client_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_budget"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/remove_budget(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_budget_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_budget"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/remove_card(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_card_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_card"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/remove_confirmation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_confirmation_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_projects/:id/remove_confirmation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_confirmation_user_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations/remove_confirmations(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_confirmations_organization_user_organizations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[6,"remove_confirmations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_and_activities_reports/remove_custom_filter(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_custom_filter_organization_time_and_activities_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_and_activities_reports"],[2,[7,"/"],[2,[6,"remove_custom_filter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/remove_payout_methods_modal/:slot(.:format)
 * @param {any} id
 * @param {any} slot
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_payout_methods_modal_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"slot":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"remove_payout_methods_modal"],[2,[7,"/"],[2,[3,"slot"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /schedules/:id/remove_shifts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_shifts_attendance_schedule_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_shifts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_orders/:work_order_id/jobs/:id/reopen(.:format)
 * @param {any} organization_id
 * @param {any} work_order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopen_organization_work_order_job_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"work_order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/reopen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopen_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /report/:signature(.:format)
 * @param {any} signature
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_path = /*#__PURE__*/ __route({"signature":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"report"],[2,[7,"/"],[2,[3,"signature"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_members_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/projects(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_projects_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/tasks(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_tasks_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/repositories(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const repositories_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"repositories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/addons/request_access(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_access_organization_addons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[6,"request_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /welcome/request_join(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_join_welcome_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"welcome"],[2,[7,"/"],[2,[6,"request_join"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/request_password_reset/:user_id(.:format)
 * @param {any} organization_id
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_password_reset_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"request_password_reset"],[2,[7,"/"],[2,[3,"user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /welcome/request_sent(/:token)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_sent_welcome_path = /*#__PURE__*/ __route({"token":{},"format":{}}, [2,[7,"/"],[2,[6,"welcome"],[2,[7,"/"],[2,[6,"request_sent"],[2,[1,[2,[7,"/"],[3,"token"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/payee_accounts/requirements(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requirements_organization_payee_accounts_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[6,"requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:payer_account_id/payee_accounts/requirements(.:format)
 * @param {any} payer_account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requirements_payer_account_payee_accounts_path = /*#__PURE__*/ __route({"payer_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"payer_account_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[6,"requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/reschedule_reminder_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reschedule_reminder_modal_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"reschedule_reminder_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reseller/billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resellers_billing_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reseller"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reseller/billing/details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resellers_billing_details_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reseller"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reseller/clients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resellers_clients_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reseller"],[2,[7,"/"],[2,[6,"clients"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reseller/dismiss_overview_banner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resellers_dismiss_overview_banner_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reseller"],[2,[7,"/"],[2,[6,"dismiss_overview_banner"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reseller/billing/details/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resellers_edit_billing_details_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reseller"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"details"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reseller/organizations/:id/sso_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resellers_organization_sso_status_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reseller"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sso_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reseller/overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resellers_overview_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reseller"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reseller/organizations/:id/proxy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resellers_proxy_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reseller"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"proxy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reseller(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resellers_root_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reseller"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /reseller/send_assistance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resellers_send_assistance_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reseller"],[2,[7,"/"],[2,[6,"send_assistance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /invites/:id/resend(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_invite_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/reset_provisioned_password/:user_id(.:format)
 * @param {any} organization_id
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_provisioned_password_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"reset_provisioned_password"],[2,[7,"/"],[2,[3,"user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/paid_addons/:addon_sym/restart_trial(.:format)
 * @param {any} organization_id
 * @param {any} addon_sym
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restart_trial_organization_paid_addons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"addon_sym":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"paid_addons"],[2,[7,"/"],[2,[3,"addon_sym"],[2,[7,"/"],[2,[6,"restart_trial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /clients/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_client_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /overtime_policies/:id/restore_conflicting_members_dialog_wired(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_conflicting_members_overtime_policy_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"overtime_policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore_conflicting_members_dialog_wired"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/clients/restore_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_multiple_organization_clients_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"restore_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/projects/restore_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_multiple_organization_projects_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"restore_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_break_policies/:id/restore(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_organization_work_break_policy_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_break_policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/work_orders/:id/restore(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_organization_work_order_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /overtime_policies/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_overtime_policy_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"overtime_policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /time_off_policies/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_time_off_policy_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"time_off_policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/resume_subscription(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resume_subscription_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resume_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/retrieve_referral_code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retrieve_referral_code_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"retrieve_referral_code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/retry(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retry_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/retry_multiple_projects(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retry_multiple_projects_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry_multiple_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/ai_manager/briefings/:id/retry(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retry_organization_ai_manager_briefing_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"ai_manager"],[2,[7,"/"],[2,[6,"briefings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/retry_project(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retry_project_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry_project"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:id/retry_syncs(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retry_syncs_payer_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry_syncs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/retry_warm_time_off_policies(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retry_warm_time_off_policies_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry_warm_time_off_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_and_activities_reports/rollup(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rollup_organization_time_and_activities_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_and_activities_reports"],[2,[7,"/"],[2,[6,"rollup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /s3/announcements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const s3_announcements_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"s3"],[2,[7,"/"],[2,[6,"announcements"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /saved_report_filters/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saved_report_filter_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"saved_report_filters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /saved_report_filters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saved_report_filters_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"saved_report_filters"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/sca_confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sca_confirm_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sca_confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scheduled_reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduled_report_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"scheduled_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scheduled_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduled_reports_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"scheduled_reports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /screens/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const screen_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"screens"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /screens(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const screens_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"screens"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/screenshots/screenshots_per_os(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const screenshots_per_os_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"screenshots"],[2,[7,"/"],[2,[6,"screenshots_per_os"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/search_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"search_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/security(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"security"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/select_account(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_account_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"select_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/payer_accounts/:id/select_account(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_account_organization_payer_account_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"select_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/select_collaborators(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_collaborators_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"select_collaborators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /welcome/select_industry(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_industry_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"welcome"],[2,[7,"/"],[2,[6,"select_industry"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/select_organization(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_organization_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"select_organization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/select_projects(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_projects_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"select_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/select_repositories(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_repositories_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"select_repositories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/select_tenant(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_tenant_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"select_tenant"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/select_time_off_policies(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_time_off_policies_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"select_time_off_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/select_users(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_users_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"select_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/send_connect_reminder(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_connect_reminder_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_connect_reminder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/send_dialog(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_dialog_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/send_download_instructions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_download_instructions_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_download_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/send_invite_example(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_invite_example_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_invite_example"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:id/send(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/client_invoices/send_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_multiple_organization_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"client_invoices"],[2,[7,"/"],[2,[6,"send_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_invoices/send_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_multiple_organization_user_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_invoices"],[2,[7,"/"],[2,[6,"send_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/invites/send_onboarding_email(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_onboarding_email_organization_invites_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[6,"send_onboarding_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user/send_referral_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_referral_email_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"send_referral_email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/send_reminders_batch(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_reminders_batch_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"send_reminders_batch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/send_reminders_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_reminders_modal_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"send_reminders_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/send_report(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_report_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"send_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/send_report_check(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_report_check_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"send_report_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/custom_report_emails/send_report_dialog(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_report_dialog_organization_custom_report_emails_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"custom_report_emails"],[2,[7,"/"],[2,[6,"send_report_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/custom_report_emails/send_report(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_report_organization_custom_report_emails_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"custom_report_emails"],[2,[7,"/"],[2,[6,"send_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /welcome/send_request(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_request_welcome_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"welcome"],[2,[7,"/"],[2,[6,"send_request"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /invoices/I/:id/send(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_user_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"I"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /session/signed_tasks_access_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_signed_tasks_access_token_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"signed_tasks_access_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /session/time_zone(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_time_zone_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"time_zone"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/set_payouts_modal/:enable(.:format)
 * @param {any} id
 * @param {any} enable
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_payouts_modal_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"enable":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"set_payouts_modal"],[2,[7,"/"],[2,[3,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/set_reminder(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_reminder_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"set_reminder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/billing/invoices/settings(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_organization_stripe_invoices_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:id/settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_payer_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/role_permissions(/:tab)(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_role_permissions_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"tab":{},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"role_permissions"],[2,[1,[2,[7,"/"],[3,"tab"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/timesheets/modify_time_rules(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_timesheets_modify_time_rules_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[6,"modify_time_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/update_role_setting(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_update_role_setting_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"update_role_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/setup(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setup_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/setup_summary_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setup_summary_modal_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"setup_summary_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /link/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shared_link_path = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"link"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/holidays/shift_count_on_request(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shift_count_on_request_organization_holidays_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"holidays"],[2,[7,"/"],[2,[6,"shift_count_on_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_off_requests/shift_count_on_request(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shift_count_on_request_organization_time_off_requests_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_off_requests"],[2,[7,"/"],[2,[6,"shift_count_on_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /time_off_requests/:id/shift_overlap_confirmation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shift_overlap_confirmation_time_off_request_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"time_off_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"shift_overlap_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/show_billing(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_billing_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /activities/show_dialog(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_dialog_activities_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"show_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications/show_more(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_more_notifications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"show_more"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/show_receipt(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_receipt_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/show_schedule_report_toast(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_schedule_report_toast_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"show_schedule_report_toast"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/sidebar(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sidebar_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sidebar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /signup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signup_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"signup"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/smart_notification_rules/slack_users(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const slack_users_organization_smart_notification_rules_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"smart_notification_rules"],[2,[7,"/"],[2,[6,"slack_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/smart_notification_rules(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const smart_notification_rules_organization_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"smart_notification_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/split_payment_warning_dialog(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const split_payment_warning_dialog_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"split_payment_warning_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/sso(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sso_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/paid_addons/:addon_sym/start_trial(.:format)
 * @param {any} organization_id
 * @param {any} addon_sym
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_trial_organization_paid_addons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"addon_sym":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"paid_addons"],[2,[7,"/"],[2,[3,"addon_sym"],[2,[7,"/"],[2,[6,"start_trial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const status_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/wizard/:id/store_selected_options(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const store_selected_options_organization_integration_wizard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"wizard"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"store_selected_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/stripe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_webhook_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"stripe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/submit_ip_location_feedback(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_ip_location_feedback_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_ip_location_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/getting_started/substep(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const substep_organization_getting_started_index_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"getting_started"],[2,[7,"/"],[2,[6,"substep"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/insights_onboarding/substep(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const substep_organization_insights_onboarding_index_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"insights_onboarding"],[2,[7,"/"],[2,[6,"substep"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /auth_payment/success(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const success_auth_payments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth_payment"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/suggest(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suggest_organization_integrations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"suggest"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/smart_notification_rules/suggest(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suggest_organization_smart_notification_rules_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"smart_notification_rules"],[2,[7,"/"],[2,[6,"suggest"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/sync(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/sync_integrations_dialog(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_integrations_dialog_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync_integrations_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/integrations/:id/sync_project(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_project_organization_integration_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync_project"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/sync_projects_manually(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_projects_manually_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync_projects_manually"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:id/sync_users(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_users_payer_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_and_activities_reports/table(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const table_organization_time_and_activities_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_and_activities_reports"],[2,[7,"/"],[2,[6,"table"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/batch_manual_time_entries/tasks(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tasks_organization_batch_manual_time_entries_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"batch_manual_time_entries"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/amounts_owed(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_amounts_owed_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"amounts_owed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/apps_and_urls(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_apps_and_urls_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"apps_and_urls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/attendance(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_attendance_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"attendance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/audit_logs(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_audit_logs_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"audit_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/audit_logs/members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_audit_logs_reports_members_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"audit_logs"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/audit_logs/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_audit_logs_reports_show_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"audit_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/client_budgets(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_client_budgets_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"client_budgets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/client_invoices_aging(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_client_invoices_aging_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"client_invoices_aging"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/client_invoices(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_client_invoices_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"client_invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/custom_time_and_activities(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_custom_time_and_activities_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"custom_time_and_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/daily_chart(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_daily_chart_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"daily_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/daily_limits(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_daily_limits_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"daily_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/daily(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_daily_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"daily"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/:organization_id/team(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_dashboard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/expenses(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_expenses_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"expenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/job_attendance(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_job_attendance_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"job_attendance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/job_sites(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_job_sites_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"job_sites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/manual_time_log(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_manual_time_log_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"manual_time_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:id/members(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_members_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/amounts_owed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_amounts_owed_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"amounts_owed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/apps_and_urls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_apps_and_urls_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"apps_and_urls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/attendance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_attendance_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"attendance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/audit_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_audit_logs_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"audit_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/client_budgets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_client_budgets_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"client_budgets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/client_invoices_aging(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_client_invoices_aging_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"client_invoices_aging"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/client_invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_client_invoices_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"client_invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/custom_time_and_activities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_custom_time_and_activities_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"custom_time_and_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/daily_limits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_daily_limits_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"daily_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/daily(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_daily_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"daily"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/expenses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_expenses_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"expenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/job_attendance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_job_attendance_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"job_attendance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/job_sites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_job_sites_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"job_sites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/manual_time_log(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_manual_time_log_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"manual_time_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_payments_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/project_budgets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_project_budgets_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"project_budgets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/team_invoices_aging(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_team_invoices_aging_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"team_invoices_aging"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/team_invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_team_invoices_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"team_invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/time_and_activities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_time_and_activities_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"time_and_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/time_off_balances(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_time_off_balances_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"time_off_balances"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/time_off_transactions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_time_off_transactions_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"time_off_transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/timesheets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_timesheets_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"timesheets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/weekly_limits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_weekly_limits_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"weekly_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/work_breaks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_work_breaks_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"work_breaks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/team/work_sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_old_work_sessions_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"work_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /team_payment_notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_payment_note_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payment_notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:team_payment_id/team_payment_notes(.:format)
 * @param {any} team_payment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_payment_team_payment_notes_path = /*#__PURE__*/ __route({"team_payment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"team_payment_id"],[2,[7,"/"],[2,[6,"team_payment_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/payments(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_payments_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:team_id/projects/:id(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_project_path = /*#__PURE__*/ __route({"team_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/project_budgets(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_project_budgets_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"project_budgets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:id/projects(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_projects_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/team_invoices_aging(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_team_invoices_aging_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"team_invoices_aging"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/team_invoices(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_team_invoices_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"team_invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:team_id/members/:id(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_team_member_path = /*#__PURE__*/ __route({"team_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:team_id/projects/:id(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_team_project_path = /*#__PURE__*/ __route({"team_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/time_and_activities(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_time_and_activities_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"time_and_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/time_off_balances(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_time_off_balances_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"time_off_balances"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/time_off_transactions(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_time_off_transactions_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"time_off_transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/timesheets(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_timesheets_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"timesheets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/weekly_limits(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_weekly_limits_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"weekly_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/work_breaks(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_work_breaks_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"work_breaks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/:organization_id/team/work_sessions(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_work_sessions_reports_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"work_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/teams_dropdown(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teams_dropdown_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"teams_dropdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/schedules/teams(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teams_organization_attendance_schedules_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_off_requests/teams(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teams_organization_time_off_requests_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_off_requests"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/timesheets/teams(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teams_organization_timesheets_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/teams(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teams_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /time_entries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_entries_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"time_entries"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /timesheets/:id/time_entries(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_entries_timesheet_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"time_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /time_entries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_entry_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/time_off_balances/pre_import_summary(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_off_balances_pre_import_summary_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"time_off_balances"],[2,[7,"/"],[2,[6,"pre_import_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/time_off(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_off_policies_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"time_off"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /time_off_policies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_off_policy_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"time_off_policies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /time_off_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_off_request_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"time_off_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /time_off_requests/:id/time_off_request_days(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_off_request_days_time_off_request_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"time_off_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"time_off_request_days"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notes/time_slot(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_slot_notes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[6,"time_slot"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/batch_manual_time_entries/timeline_entries(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timeline_entries_organization_batch_manual_time_entries_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"batch_manual_time_entries"],[2,[7,"/"],[2,[6,"timeline_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /timer/check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timer_check_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"timer"],[2,[7,"/"],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /timer/projects(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timer_projects_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"timer"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/timer_screenshot_hint_seen(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timer_screenshot_hint_seen_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"timer_screenshot_hint_seen"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /timer/tracking_state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timer_tracking_state_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"timer"],[2,[7,"/"],[2,[6,"tracking_state"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /timesheets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timesheet_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/timesheets/timesheet_approvals(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timesheet_approvals_settings_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[6,"timesheet_approvals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/timesheet_approvals_settings_confirmation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timesheet_approvals_settings_confirmation_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"timesheet_approvals_settings_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/timesheet_modify_time_allowed_settings_confirmation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timesheet_modify_time_allowed_settings_confirmation_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"timesheet_modify_time_allowed_settings_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/timesheets/modify_time_and_manual_requests(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timesheet_modify_time_and_manual_requests_settings_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[6,"modify_time_and_manual_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /timesheets/:id/timesheet_panel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timesheet_panel_timesheet_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"timesheet_panel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/timesheets/time_entry_reasons(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timesheet_setting_entry_reasons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[6,"time_entry_reasons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_payments/timesheets(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timesheets_organization_team_payments_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[6,"timesheets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/timesheets/update_entry_reasons(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timesheets_setting_update_entry_reasons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[6,"update_entry_reasons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/toggle(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_dashboard_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/:team_id/members/:id/toggle_lead(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_lead_team_team_member_path = /*#__PURE__*/ __route({"team_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_lead"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/smart_notification_rules/:id/toggle(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_organization_smart_notification_rule_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"smart_notification_rules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/smart_notification_rules/tool_list(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tool_list_organization_smart_notification_rules_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"smart_notification_rules"],[2,[7,"/"],[2,[6,"tool_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /totals_changed/invoice(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const totals_changed_invoice_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"totals_changed"],[2,[7,"/"],[2,[6,"invoice"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /totals_changed/user_invoice(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const totals_changed_user_invoice_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"totals_changed"],[2,[7,"/"],[2,[6,"user_invoice"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /referral/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const track_referral_path = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"referral"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/insights/track_retention_offer(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const track_retention_offer_organization_insights_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"insights"],[2,[7,"/"],[2,[6,"track_retention_offer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/transfer(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transfer_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"transfer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/transfer_purpose_requirements(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transfer_purpose_requirements_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"transfer_purpose_requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/payee_accounts/transfer_requirements(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transfer_requirements_organization_payee_accounts_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[6,"transfer_requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:payer_account_id/payee_accounts/transfer_requirements(.:format)
 * @param {any} payer_account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transfer_requirements_payer_account_payee_accounts_path = /*#__PURE__*/ __route({"payer_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"payer_account_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[6,"transfer_requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/clients/unified_dialog_create(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unified_dialog_create_organization_clients_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"unified_dialog_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /clients/:id/unified_dialog_update(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unified_dialog_update_client_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unified_dialog_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/unified_dialog_update(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unified_dialog_update_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unified_dialog_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/unified_dialog_update(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unified_dialog_update_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unified_dialog_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/unlink_multiple_projects(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlink_multiple_projects_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unlink_multiple_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/unlink_multiple_users(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlink_multiple_users_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unlink_multiple_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/unlink(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlink_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unlink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/unlink(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlink_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unlink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/unlink_project(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlink_project_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unlink_project"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/unlink_user(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlink_user_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unlink_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /unsubscribe/:signature(.:format)
 * @param {any} signature
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_path = /*#__PURE__*/ __route({"signature":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"unsubscribe"],[2,[7,"/"],[2,[3,"signature"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/update_backup_integration_batch(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_backup_integration_batch_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"update_backup_integration_batch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/update_billing(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_billing_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /clients/:id/update_budget(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_budget_client_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_budget"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/update_budget(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_budget_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_budget"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/:organization_id/update(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_dashboard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /timesheets/:id/update_denial_reason_dialog_wired(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_denial_reason_dialog_wired_timesheet_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_denial_reason_dialog_wired"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /timesheets/:id/update_denial_reason(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_denial_reason_timesheet_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_denial_reason"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations/update_favorite_menu(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_favorite_menu_organization_user_organizations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[6,"update_favorite_menu"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /team_payments/:id/update_friendly_name(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_friendly_name_team_payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_friendly_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/update_invoice_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_invoice_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_invoice_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/update_invoicing(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_invoicing_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_invoicing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/:id/update_lead_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_lead_settings_team_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_lead_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations/update_limit_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_limit_multiple_organization_user_organizations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[6,"update_limit_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/update_member_profile_fields(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_member_profile_fields_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_member_profile_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /holidays/:id/update_members(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_members_holiday_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"holidays"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/update_mfa(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_mfa_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_mfa"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/update_modify_time_allowed_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_modify_time_allowed_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_modify_time_allowed_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/update_modify_time_allowed_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_modify_time_allowed_settings_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_modify_time_allowed_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations/update_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_multiple_organization_user_organizations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[6,"update_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/user_projects/update_multiple(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_multiple_project_user_projects_path = /*#__PURE__*/ __route({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"user_projects"],[2,[7,"/"],[2,[6,"update_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/update_notification_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_notification_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_notification_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/update_pay_period_batch(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_pay_period_batch_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"update_pay_period_batch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations/update_pay_periods_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_pay_periods_multiple_organization_user_organizations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[6,"update_pay_periods_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/update_pay_rate_batch(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_pay_rate_batch_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"update_pay_rate_batch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invites/:id/update_pay_rate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_pay_rate_invite_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_pay_rate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invites/update_pay_rate_multiple(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_pay_rate_multiple_invites_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[6,"update_pay_rate_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_projects/update_pay_rate_multiple(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_pay_rate_multiple_user_projects_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user_projects"],[2,[7,"/"],[2,[6,"update_pay_rate_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_projects/:id/update_pay_rate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_pay_rate_user_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_pay_rate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/update_payment_info(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_payment_info_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_payment_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/update_payment_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_payment_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_payment_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/:organization_id/update_pinned_members(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_pinned_members_dashboard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"update_pinned_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/update_plan(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_plan_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/update_primary_integration_batch(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_primary_integration_batch_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"update_primary_integration_batch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/update_projects(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_projects_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/update_remove_payout_methods_batch(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_remove_payout_methods_batch_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"update_remove_payout_methods_batch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/scim(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_scim_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"scim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/payroll/update_set_payouts_batch(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_set_payouts_batch_payroll_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payroll"],[2,[7,"/"],[2,[6,"update_set_payouts_batch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/update_setting(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_setting_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/user_organizations/update_setting_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_setting_multiple_organization_user_organizations_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[6,"update_setting_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/update_setting(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_setting_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/projects/:id/update_setting(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_setting_organization_project_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:id/update_setting(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_setting_payer_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/update_setting(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_setting_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/update_setting(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_setting_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/update_silent_screenshot_os_setting(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_silent_screenshot_os_setting_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_silent_screenshot_os_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/sso(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_sso_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /timesheets/:id/update_status_dialog(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_status_dialog_timesheet_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_status_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /timesheets/:id/update_status_dialog_wired(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_status_dialog_wired_timesheet_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_status_dialog_wired"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/timesheets/update_status_multiple_dialog(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_status_multiple_dialog_organization_timesheets_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[6,"update_status_multiple_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/timesheets/update_status_multiple_dialog_wired(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_status_multiple_dialog_wired_organization_timesheets_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[6,"update_status_multiple_dialog_wired"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_off_requests/update_status_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_status_multiple_organization_time_off_requests_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_off_requests"],[2,[7,"/"],[2,[6,"update_status_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/timesheets/update_status_multiple(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_status_multiple_organization_timesheets_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[6,"update_status_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/timesheets/update_status_multiple_wired(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_status_multiple_wired_organization_timesheets_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[6,"update_status_multiple_wired"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /time_off_requests/:id/update_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_status_time_off_request_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"time_off_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /timesheets/:id/update_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_status_timesheet_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"timesheets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/getting_started/update_substep(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_substep_organization_getting_started_index_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"getting_started"],[2,[7,"/"],[2,[6,"update_substep"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/insights_onboarding/update_substep(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_substep_organization_insights_onboarding_index_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"insights_onboarding"],[2,[7,"/"],[2,[6,"update_substep"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invites/:id/update_teams(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_teams_invite_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/update_teams(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_teams_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/update_teams(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_teams_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/update_timesheet_approvals_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_timesheet_approvals_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_timesheet_approvals_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/update_trackable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_trackable_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_trackable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_projects/:id/update_trackable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_trackable_user_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_trackable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invites/:id/update_weekly_limit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_weekly_limit_invite_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_weekly_limit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invites/update_weekly_limit_multiple(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_weekly_limit_multiple_invites_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[6,"update_weekly_limit_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /time_entries/:id/update_with_manual_time_requests(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_with_manual_time_requests_time_entry_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_with_manual_time_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/update_work_limits_and_expectations_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_work_limits_and_expectations_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_work_limits_and_expectations_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/update_work_targets_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_work_targets_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_work_targets_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id/update_work_targets_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_work_targets_settings_user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_work_targets_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/paid_addons/:addon_sym/upsell_dialog(.:format)
 * @param {any} organization_id
 * @param {any} addon_sym
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upsell_dialog_organization_paid_addons_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"addon_sym":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"paid_addons"],[2,[7,"/"],[2,[3,"addon_sym"],[2,[7,"/"],[2,[6,"upsell_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /activities/urls_detailed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const urls_detailed_activities_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"urls_detailed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/activities/urls_detailed(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const urls_detailed_organization_activities_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"activities"],[2,[7,"/"],[2,[6,"urls_detailed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/usage_data(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usage_data_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"usage_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/insights/usage_data(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usage_data_organization_insights_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"insights"],[2,[7,"/"],[2,[6,"usage_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /time_off_policies/:id/user_balance(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_balance_time_off_policy_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"time_off_policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"user_balance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /time_off_requests/user_balance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_balance_time_off_requests_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"time_off_requests"],[2,[7,"/"],[2,[6,"user_balance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/benchmarks_has_seen_dialog(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_benchmarks_has_seen_dialog_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"benchmarks_has_seen_dialog"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/create_in_organization/:organization_id(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_create_in_organization_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"create_in_organization"],[2,[7,"/"],[2,[3,"organization_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/dismiss_intro_video(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_dismiss_intro_video_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"dismiss_intro_video"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/dismiss_reseller_banner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_dismiss_reseller_banner_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"dismiss_reseller_banner"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/dismiss_welcome_mat/:welcome_mat(.:format)
 * @param {any} welcome_mat
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_dismiss_welcome_mat_path = /*#__PURE__*/ __route({"welcome_mat":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"dismiss_welcome_mat"],[2,[7,"/"],[2,[3,"welcome_mat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/dismiss_welcome_video(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_dismiss_welcome_video_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"dismiss_welcome_video"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/email_subscriptions/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_email_subscription_path = /*#__PURE__*/ __route({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"email_subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/email_subscriptions(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_email_subscriptions_path = /*#__PURE__*/ __route({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"email_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user_events"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /user/hide_activity_info_banner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_hide_activity_info_banner_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"hide_activity_info_banner"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/hide_corporate_upsell_banner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_hide_corporate_upsell_banner_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"hide_corporate_upsell_banner"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/holidays/user_holidays(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_holidays_organization_holidays_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"holidays"],[2,[7,"/"],[2,[6,"user_holidays"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user/hubstaff_insights_registration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_hubstaff_insights_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"hubstaff_insights_registration"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /invoices/I/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"I"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/I/:unique_hash_token(.:format)
 * @param {any} unique_hash_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_invoice_as_client_path = /*#__PURE__*/ __route({"unique_hash_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"I"],[2,[7,"/"],[2,[3,"unique_hash_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/I/:user_invoice_id/invoice_payments/:id(.:format)
 * @param {any} user_invoice_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_invoice_invoice_payment_path = /*#__PURE__*/ __route({"user_invoice_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"I"],[2,[7,"/"],[2,[3,"user_invoice_id"],[2,[7,"/"],[2,[6,"invoice_payments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/I/:user_invoice_id/invoice_payments(.:format)
 * @param {any} user_invoice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_invoice_invoice_payments_path = /*#__PURE__*/ __route({"user_invoice_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"I"],[2,[7,"/"],[2,[3,"user_invoice_id"],[2,[7,"/"],[2,[6,"invoice_payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/I/:unique_hash_token/pdf(.:format)
 * @param {any} unique_hash_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_invoice_pdf_as_client_path = /*#__PURE__*/ __route({"unique_hash_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"I"],[2,[7,"/"],[2,[3,"unique_hash_token"],[2,[7,"/"],[2,[6,"pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/I/:unique_hash_token/printed(.:format)
 * @param {any} unique_hash_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_invoice_printed_as_client_path = /*#__PURE__*/ __route({"unique_hash_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"I"],[2,[7,"/"],[2,[3,"unique_hash_token"],[2,[7,"/"],[2,[6,"printed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/user_list(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_list_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"user_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /payer_accounts/:id/user_list(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_list_payer_account_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payer_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"user_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:user_organization_id/payee_accounts/:id(.:format)
 * @param {any} user_organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_organization_payee_account_path = /*#__PURE__*/ __route({"user_organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"user_organization_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_organizations/:user_organization_id/rates(.:format)
 * @param {any} user_organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_organization_rates_path = /*#__PURE__*/ __route({"user_organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_organizations"],[2,[7,"/"],[2,[3,"user_organization_id"],[2,[7,"/"],[2,[6,"rates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/payee_accounts/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_payee_account_path = /*#__PURE__*/ __route({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"payee_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/payee_default_accounts/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_payee_default_account_path = /*#__PURE__*/ __route({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"payee_default_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/payee_default_accounts(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_payee_default_accounts_path = /*#__PURE__*/ __route({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"payee_default_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_off_policies/user_policies(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_policies_organization_time_off_policies_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_off_policies"],[2,[7,"/"],[2,[6,"user_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_projects/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_project_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_projects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /whats_new/:announcement/track_announcement(.:format)
 * @param {any} announcement
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_track_announcement_path = /*#__PURE__*/ __route({"announcement":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"whats_new"],[2,[7,"/"],[2,[3,"announcement"],[2,[7,"/"],[2,[6,"track_announcement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /unmet_requirements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unmet_requirements_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"unmet_requirements"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /integrations/:id/users(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_integration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/team_payments/validate_bonus(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_bonus_organization_team_payments_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"team_payments"],[2,[7,"/"],[2,[6,"validate_bonus"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/holidays/validate_members_csv(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_members_csv_organization_holidays_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"holidays"],[2,[7,"/"],[2,[6,"validate_members_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/holidays/validate(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_organization_holidays_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"holidays"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_off_requests/validate(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_organization_time_off_requests_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_off_requests"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_entries/weekly_export(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weekly_export_organization_time_entries_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"weekly_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/time_entries/weekly(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weekly_organization_time_entries_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"time_entries"],[2,[7,"/"],[2,[6,"weekly"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /welcome(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcome_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"welcome"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dashboard/:organization_id/widget_batch/:dashboard_type(.:format)
 * @param {any} organization_id
 * @param {any} dashboard_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const widget_batch_dashboard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"dashboard_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"widget_batch"],[2,[7,"/"],[2,[3,"dashboard_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/:organization_id/widget/:dashboard_type/:widget_id(.:format)
 * @param {any} organization_id
 * @param {any} dashboard_type
 * @param {any} widget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const widget_dashboard_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"dashboard_type":{"r":true},"widget_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"widget"],[2,[7,"/"],[2,[3,"dashboard_type"],[2,[7,"/"],[2,[3,"widget_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/:organization_id/widget/:dashboard_type/:widget_id/:widget_action(.:format)
 * @param {any} organization_id
 * @param {any} dashboard_type
 * @param {any} widget_id
 * @param {any} widget_action
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const widget_dashboard_action_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"dashboard_type":{"r":true},"widget_id":{"r":true},"widget_action":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"widget"],[2,[7,"/"],[2,[3,"dashboard_type"],[2,[7,"/"],[2,[3,"widget_id"],[2,[7,"/"],[2,[3,"widget_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/work_breaks/notifications(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_break_notifications_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_breaks"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/settings/work_breaks(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_break_policies_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_breaks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:organization_id/batch_manual_time_entries/work_break_policies(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_break_policies_organization_batch_manual_time_entries_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"batch_manual_time_entries"],[2,[7,"/"],[2,[6,"work_break_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/:id/settings/work_time_limits(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_limits_and_expectations_settings_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_time_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /zone/docs/*id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const zone_docs_path = /*#__PURE__*/ __route({"id":{"r":true}}, [2,[7,"/"],[2,[6,"zone"],[2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[5,[3,"id"]]]]]]]);

/**
 * Generates rails route to
 * /zone/vue-docs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const zone_vue_docs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"zone"],[2,[7,"/"],[2,[6,"vue-docs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

